import React from "react";
import { spacing } from "@/config/theme";
import { TimesheetEntry } from "@/time-tracking/types/Timesheet";
import {
  getEntryCategoryOptions,
  handleNumberInputKeyDown,
} from "@/time-tracking/utils";
import { DeleteOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import { Button, InputNumber, Select } from "antd";
import { MINUTE } from "@/constants/time";

const EntryItemWrapper = styled.div`
  margin-bottom: ${spacing.xxs};
  display: flex;
  gap: ${spacing.xxs};
`;

const StyledInputNumber = styled(InputNumber)`
  flex: 0.8;
`;

const DeleteButtonContainer = styled.div`
  width: 32px;
`;

const EntryItem = ({
  entry,
  disableEditing = false,
  handleDeleteEntry,
  handleUpdateEntry,
}: {
  entry: TimesheetEntry;
  handleDeleteEntry: (entryId: number | string) => void;
  handleUpdateEntry: (
    entryId: number | string,
    updatedFields: Partial<TimesheetEntry>
  ) => void;
  disableEditing?: boolean;
}) => {
  return (
    <li>
      <EntryItemWrapper>
        <Select
          style={{ flex: 2 }}
          placeholder="Category"
          value={entry.type}
          options={getEntryCategoryOptions()}
          onChange={(value) => {
            if (entry.id) {
              if (value === "SICK") {
                handleUpdateEntry(entry.id, {
                  type: value,
                  minutes: 0,
                  time: ((entry.hours ?? 0) * 60 * MINUTE).toString(),
                });
              } else if (value === "LOA") {
                handleUpdateEntry(entry.id, {
                  type: value,
                  hours: 0,
                  minutes: 0,
                  time: "0",
                });
              } else {
                handleUpdateEntry(entry.id, { type: value });
              }
            }
          }}
          disabled={disableEditing}
        />
        <StyledInputNumber
          controls={false}
          value={entry.hours}
          suffix="h"
          min={0}
          max={24}
          onKeyDown={handleNumberInputKeyDown}
          onChange={(value) => {
            if (entry.id) {
              handleUpdateEntry(entry.id, {
                hours: Number(value) ?? 0,
                time: (
                  ((Number(value) ?? 0) * 60 + (entry.minutes ?? 0)) *
                  60 *
                  1000
                ).toString(),
              });
            }
          }}
          disabled={disableEditing || entry.type === "LOA"}
        />
        <StyledInputNumber
          controls={false}
          value={entry.minutes}
          suffix="min"
          min={0}
          max={59}
          onKeyDown={handleNumberInputKeyDown}
          onChange={(value) => {
            if (entry.id) {
              handleUpdateEntry(entry.id, {
                minutes: Number(value) ?? 0,
                time: (
                  ((entry.hours ?? 0) * 60 + (Number(value) ?? 0)) *
                  60 *
                  1000
                ).toString(),
              });
            }
          }}
          disabled={
            disableEditing || entry.type === "LOA" || entry.type === "SICK"
          }
        />
        <DeleteButtonContainer>
          {!disableEditing && (
            <Button
              onClick={() => {
                if (entry.id) {
                  handleDeleteEntry(entry.id);
                }
              }}
              danger
              icon={<DeleteOutlined />}
            />
          )}
        </DeleteButtonContainer>
      </EntryItemWrapper>
    </li>
  );
};

export default EntryItem;
